import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  ImportableErpPartDetailsData,
  ImportableErpPartDetailsQueryKey,
  UseImportableErpPartDetailsParams,
} from './types';
import { getImportableErpPartDetailsQueryKey } from './util';

export const useImportableErpPartDetails: QueryFunction<
  ImportableErpPartDetailsData,
  [UseImportableErpPartDetailsParams],
  ImportableErpPartDetailsQueryKey
> = (params, queryFunctionOptions = {}) => {
  const { requestOptions, queryOptions } = queryFunctionOptions;
  const request = useRequest(requestOptions);
  const queryKey = getImportableErpPartDetailsQueryKey(params);

  return useQuery<
    ImportableErpPartDetailsData,
    unknown,
    ImportableErpPartDetailsData,
    ImportableErpPartDetailsQueryKey
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/erp_stores/historical_work_preview`, {
        init: {
          method: 'POST',
          body: params,
          signal,
        },
      });
    },
  });
};
